import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { useI18n } from "../lib/i18n";
import { Layout } from "../components/Layout";
import { Briefcase, MapPin, Plus, ArrowRight, Funnel } from "@phosphor-icons/react";
import { useAuth } from "../lib/auth";

const TYPES = [
  { v: "", l: "All" },
  { v: "job", l: "Job" },
  { v: "gig", l: "Gig" },
  { v: "apprenticeship", l: "Apprenticeship" },
  { v: "rfq", l: "RFQ" },
];

export default function Opportunities() {
  const { t } = useI18n();
  const { user } = useAuth();
  const [skills, setSkills] = useState([]);
  const [items, setItems] = useState([]);
  const [skill, setSkill] = useState("");
  const [city, setCity] = useState("");
  const [type, setType] = useState("");

  useEffect(() => { api.get("/skills").then(({ data }) => setSkills(data.skills)); }, []);
  useEffect(() => {
    const params = new URLSearchParams();
    if (skill) params.set("skill", skill);
    if (city) params.set("city", city);
    if (type) params.set("type", type);
    api.get(`/opportunities?${params.toString()}`).then(({ data }) => setItems(data));
  }, [skill, city, type]);

  return (
    <Layout>
      <div className="max-w-6xl mx-auto px-6 py-10">
        <div className="flex items-center justify-between flex-wrap gap-3 mb-6">
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.18em] text-[var(--as-accent)]">{t("nav_jobs")}</div>
            <h1 className="text-3xl font-bold text-[var(--as-primary)]" style={{fontFamily:"Inter"}}>{t("search_jobs")}</h1>
          </div>
          {(user?.role === "employer" || user?.role === "msme") && (
            <Link to="/opportunities/new" className="btn-primary" data-testid="new-op-link">
              <Plus size={18} weight="bold" /> {t("new_opportunity")}
            </Link>
          )}
        </div>

        <div className="as-card p-5 grid md:grid-cols-3 gap-4 mb-6">
          <div>
            <label className="as-label flex items-center gap-1.5"><Funnel size={14} weight="duotone" />{t("filter_skill")}</label>
            <select className="as-input" value={skill} onChange={(e) => setSkill(e.target.value)} data-testid="filter-skill">
              <option value="">All skills</option>
              {skills.map((s) => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>
          <div>
            <label className="as-label">{t("filter_city")}</label>
            <input className="as-input" value={city} onChange={(e) => setCity(e.target.value)} placeholder="Hyderabad" data-testid="filter-city" />
          </div>
          <div>
            <label className="as-label">{t("op_type")}</label>
            <select className="as-input" value={type} onChange={(e) => setType(e.target.value)} data-testid="filter-type">
              {TYPES.map((tp) => <option key={tp.v} value={tp.v}>{tp.l}</option>)}
            </select>
          </div>
        </div>

        {items.length === 0 ? (
          <div className="as-card p-10 text-center text-[var(--as-text-secondary)]">{t("no_results")}</div>
        ) : (
          <div className="grid md:grid-cols-2 gap-4">
            {items.map((o) => (
              <Link to={`/opportunities/${o.id}`} key={o.id} className="as-card p-6 hover:-translate-y-1" data-testid={`op-card-${o.id}`}>
                <div className="flex items-center justify-between">
                  <span className="as-badge-pill">{o.type}</span>
                  <span className={`text-xs font-bold ${o.status === "open" ? "text-emerald-600" : "text-stone-500"}`}>{o.status}</span>
                </div>
                <h3 className="text-xl font-bold mt-3 text-[var(--as-primary)]" style={{fontFamily:"Inter"}}>{o.title}</h3>
                <p className="text-sm text-[var(--as-text-secondary)] mt-1 line-clamp-2">{o.description}</p>
                <div className="flex flex-wrap gap-1.5 mt-4">
                  {(o.required_skills || []).slice(0, 4).map((s) => <span key={s} className="as-badge-skill !text-xs">{s}</span>)}
                </div>
                <div className="mt-4 pt-4 border-t border-[var(--as-border)] flex items-center justify-between text-xs text-[var(--as-text-secondary)]">
                  <span className="inline-flex items-center gap-1.5"><MapPin size={14} weight="duotone" />{o.city || (o.remote ? "Remote" : "—")}</span>
                  <span className="inline-flex items-center gap-1.5"><Briefcase size={14} weight="duotone" />{o.posted_by_name || "—"}</span>
                  <ArrowRight size={16} weight="bold" />
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}
